import { Grid, IconButton, Typography, styled } from '@mui/material';

import { IcClose } from '@/assets/images';
import { IMasterName } from '@/models';
import { colors } from '@/theme/variables';
import { getMasterNameDisplayName } from '@/utils';

export const LinkedTableItemRoot = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 12px',
  marginBottom: 10,
  border: `1px solid ${colors.grey[10]}`,
  borderRadius: theme.spacing(),
  '& .MuiButton-text': {
    textDecoration: 'underline',
  },
  '& .MuiButtonBase-root': {
    color: colors.error.main,
  },
}));

interface LinkedTableItemProps {
  label?: string;
  onRemove: () => void;
  owner?: IMasterName;
}

export const LinkedTableItem = ({
  label,
  onRemove,
  owner,
}: LinkedTableItemProps) => {
  const displayLabel = label || (owner ? getMasterNameDisplayName(owner) : '');

  return (
    <LinkedTableItemRoot xs={12} sm={5} item>
      <Typography variant="inherit">{displayLabel}</Typography>
      <IconButton onClick={onRemove}>
        <IcClose />
      </IconButton>
    </LinkedTableItemRoot>
  );
};
